import { Row, Card, Collapse, Button, message, Modal, Select, Checkbox, InputNumber, DatePicker, } from 'antd';

import moment from 'moment';
import { useState } from 'react';
import { useParams } from 'react-router';
import { MONTHS, PAYMENT_PRODUCT_TYPE, SUBSCRIPTION_STATUS } from '../../../constants/AppConstants';
import { isSupportLead } from '../../../helpers/genericHelper';
import API from '../../../services/API';
import LoaderComponent from '../../Loader';
import AccountView from './CreditCards/AccountView';
import SilaPaymentModal from './SilaPaymentModal';
import Main from '../Main';
const { Panel } = Collapse;
const { Option } = Select;
const { RangePicker } = DatePicker;

function AvaProductUsage({
  creditCards = [], loading, ccDomains, stripeCards, getAllCreditCardData, userSummary, paymentAttempts, autoPayStatus, refreshList }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [refundModalVisible, seRrefundModalVisible] = useState(false);
  const [currentData, setCurrentData] = useState(null);

  const [currentCreditCardId, setCurrentCreditCardId] = useState(null);
  const [currentCreditCardAccountId, setCurrentCreditCardAccountId] = useState(null);

  const [modalLoading, showModalLoading] = useState(false);
  const [showChangeDueDateModal, setShowChangeDueDateModal] = useState(false);
  const [updatedDueDate, setUpdatedDueDate] = useState(null);
  const [chargeSilaModalVisible, setChargeSilaModalVisible] = useState(false);
  const [closeAssociatedAccounts, setCloseAssociatedAccounts] = useState(true);
  const [showSpendPowerModal, setShowSpendPowerModal] = useState(false);
  const [spendPowerValue, setSpendPowerValue] = useState(null);
  const [startDate, setStartDate] = useState(moment().subtract(6, 'months'));
  const [endDate, setEndDate] = useState(moment());

  let { userId } = useParams();

  const openChangeDueDateModal = (data) => {
    setCurrentCreditCardAccountId(data?.accountId);
    setShowChangeDueDateModal(true);
  }

  const closeDueDateModal = () => {
    setShowChangeDueDateModal(false);
    setUpdatedDueDate(null);
  }

  const changeDueDate = async () => {
    const creditCardAccountId = currentCreditCardAccountId;
    if (creditCardAccountId) {
      try {
        showModalLoading(true);
        //credit card id is not used in the api services
        await API.changeDueDate(userId, updatedDueDate, false, creditCardAccountId);
        message.success('Successfully changed the Due Date.');
      } catch (e) {
        message.error('Unable to change the Due Date.');
      } finally {
        setShowChangeDueDateModal(false);
        showModalLoading(false);
        getAllCreditCardData();
      }
    }
  }

  const onDueDateValueChange = (val) => {
    setUpdatedDueDate(val);
  }

  const cancelCreditCard = async () => {
    try {
      showModalLoading(true);
      //credit card id is not used in the api services
      await API.cancelCreditCard(userId, currentCreditCardId, closeAssociatedAccounts);
      message.success('Successfully cancelled the Credit Card.');
      setCloseAssociatedAccounts(true);
    } catch (e) {
      message.error('Unable to cancel the Credit Card.');
    } finally {
      showModalLoading(false);
      setModalVisible(false);
      getAllCreditCardData();
    }
  }
  
  const closeModal = () => {
    setModalVisible(false);
    setCloseAssociatedAccounts(true);
  }

  const showCancelPaymentModal = (data) => {
    setCurrentCreditCardId(data?.id);
    setModalVisible(true);
  }



  const showChargeSilaModal = (data) => {
    setCurrentCreditCardId(data?.id);
    setChargeSilaModalVisible(true);
  }


  const closeChargeSilaModal = () => {
    setChargeSilaModalVisible(false)
  }

  const showAddSpendPowerModal = () => {
    setShowSpendPowerModal(true);
  }

  const addSpendPower = async () => {
    setShowSpendPowerModal(false);
    try {
      //credit card id is not used in the api services
      await API.addSpendPower(userId, spendPowerValue * 100);
      message.success('Successfully added the Spend Power.');
    } catch (e) {
      message.error('Unable to add the Spend Power.');
    } finally {
      showModalLoading(false);
      setShowSpendPowerModal(false);
      getAllCreditCardData();
    }
  }

  const handleDateChange = (dates) => {
    setStartDate(dates[0]);
    setEndDate(dates[1])
  }


  const closeSpendPowerModal = () => {
    setShowSpendPowerModal(false);

  }

  const showRefundModalVisible = (data) => {
    setCurrentData(data);
    seRrefundModalVisible(true);
  }

  const closeRefundModal = () => {
    seRrefundModalVisible(false);
  }

  const isTransactionLimitMode = (spendModeSummary) => {
    return (spendModeSummary?.spendMode === "TRANSACTION_LIMIT");
  };
  console.log('creditcards', creditCards)
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Row className="due-date-button">
            {isSupportLead() &&
                <Button
                    type={'primary'}
                    onClick={() => showAddSpendPowerModal()}>
                  Add Spend Power
                </Button>
            }

          </Row>


          {ccDomains && ccDomains.length > 0 ? (
            ccDomains
              .map((domain) => {
                if (!domain.card || domain.card.length === 0 || creditCards.length === 0) {
                  return null;
                }
                const data = creditCards.find((cc) => domain.card.map((card) => card.id).includes(cc.id));
                if (!data) {
                  return null;
                }
                return { domain, data };
              })
              .filter(Boolean)
              .sort((a, b) => { // should be memo but in practice the cards list is very small so doesn't matter
                const aIsActive = a.data.cardStatus === 'ACTIVE' || a.data.active;
                const bIsActive = b.data.cardStatus === 'ACTIVE' || b.data.active;
                
                if (aIsActive && !bIsActive) return -1;
                if (!aIsActive && bIsActive) return 1;
                
                return (b.data.createTs || '') > (a.data.createTs || '') ? 1 : -1;
              })
              .map(({ domain, data }) => (
                <Card
                  bordered={false}
                  hoverable={true}
                  key={data.id}
                  className="criclebox tablespace mb-16 bottom-bordered-card"
                >
                  <AccountView
                    creditCard={data}
                    domain={domain}
                    userSummary={userSummary}
                    setShowSpendPowerModal={setShowSpendPowerModal}
                    userId={userId}
                    openChangeDueDateModal={openChangeDueDateModal}
                    showChangeDueDateModal={showChangeDueDateModal}
                    showChargeSilaModal={showChargeSilaModal}
                    showCancelPaymentModal={showCancelPaymentModal}
                    refreshList={refreshList}
                    paymentAttempts={paymentAttempts}
                    autoPayStatus={autoPayStatus}
                    />
                </Card>
              ))
          ) : (
            <Row className="no-data-card">No Data Found</Row>
          )}
        </>
      )}
      <Modal
        title={'Confirmation'}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        visible={modalVisible}
        onOk={cancelCreditCard}
        onCancel={closeModal}
        className="confirm-modal"
      ><>
          <p>Are you sure you want to Cancel this Credit Card?</p>
          <Checkbox checked={closeAssociatedAccounts} onChange={(e) => { setCloseAssociatedAccounts(e.target.checked); }}>
            {"Close Furnishing Account as well."}
          </Checkbox>
          {modalLoading && <LoaderComponent />}
        </>
      </Modal>


      <SilaPaymentModal
        refreshList={refreshList}
        silaModalVisible={chargeSilaModalVisible}
        closeSilaModal={closeChargeSilaModal}
        userId={userId}
        productId={currentCreditCardId}
        paymentProductType={PAYMENT_PRODUCT_TYPE.CREDIT_CARD}
      />

      <Modal
        title={'Change Due Day'}
        centered
        mask={true}
        maskClosable={true}
        okText={'Update'}
        destroyOnClose={true}
        okButtonProps={{
          disabled: !updatedDueDate
        }
        }
        closable={true}
        visible={showChangeDueDateModal}
        onOk={changeDueDate}
        onCancel={closeDueDateModal}
        className="confirm-modal"
      >
        <p>Please provide the new Due Date.</p>
        {!modalLoading &&
          <Select placeholder={"Please select new Due Date"}
            onSelect={onDueDateValueChange}
            style={{ minWidth: 200 }}>
            {MONTHS && MONTHS.map((_month) => {
              return <Option key={_month} value={_month}>{_month}</Option>
            })}
          </Select>}
        {modalLoading && <LoaderComponent tip={'Updating Due Date'} />}
      </Modal>
      <Modal
        title={'Add Spend Power'}
        centered
        mask={true}
        maskClosable={true}
        okText={'Save'}
        destroyOnClose={true}
        okButtonProps={{
          disabled: spendPowerValue === null
        }
        }
        closable={true}
        visible={showSpendPowerModal}
        onOk={addSpendPower}
        onCancel={closeSpendPowerModal}
        className="confirm-modal"
      >
        <p>Enter the Gifted Spend Power bonus in dollars.<br/><br/>Note: This overrides any previously gifted 
        amount. Review the 'Spend Power Breakdown' to see any previous gifts. Spend power has a minimum limit 
        based on user's feature flag. If you gift spend power below the minimum limit, it will be ignored.</p>
        {!modalLoading &&
          <InputNumber min={0} placeholder={'Enter Spend Power in Dollars'}
            style={{
              width: 200
            }}
            value={spendPowerValue}
            onChange={(val) => {
              setSpendPowerValue(val)
            }} />}
        {modalLoading && <LoaderComponent tip={'Adding Spend Power'} />}
      </Modal>
      {/*
      <RefundModal
        refundModalVisible={refundModalVisible}
        closeRefundModal={closeRefundModal}
        data={currentData}
        userId={userId}
        refetchUserData={refreshList}
        referenceId={currentData?.id}
        paymentProductType={PAYMENT_PRODUCT_TYPE.CREDIT_CARD}
        showCheckbox={false}
      /> */}
    </>
  );
}

export default AvaProductUsage;
